module.exports = __webpack_public_path__ + "static/media/DSCF6374_JUANS.6b67f5c5.jpg";